"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
const DangerPrizm = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: "32px",
  height: "32px",
  viewBox: "0 0 32 32"
}, props), _react.default.createElement("g", {
  stroke: "none",
  strokeWidth: "1",
  fillRule: "evenodd"
}, _react.default.createElement("g", {
  transform: "translate(5.000000, 5.000000)"
}, _react.default.createElement("path", {
  d: "M11,19.9976 C6.121,19.9976 2,15.8766 2,10.9996 C2,6.1216 6.121,1.9996 11,1.9996 C15.879,1.9996 20,6.1216 20,10.9996 C20,15.8766 15.879,19.9976 11,19.9976 M11,-0.000400000001 C16.963,-0.000400000001 22,5.0376 22,10.9996 C22,16.9616 16.963,21.9976 11,21.9976 C5.037,21.9976 0,16.9616 0,10.9996 C0,5.0376 5.037,-0.000400000001 11,-0.000400000001 Z M11,14.75 C10.31,14.75 9.75,15.31 9.75,16 C9.75,16.69 10.31,17.25 11,17.25 C11.69,17.25 12.25,16.69 12.25,16 C12.25,15.31 11.69,14.75 11,14.75 Z M11,5 C10.447,5 10,5.448 10,6 L10,12 C10,12.552 10.447,13 11,13 C11.553,13 12,12.552 12,12 L12,6 C12,5.448 11.553,5 11,5 Z"
}))));
const DangerMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}, props), _react.default.createElement("path", {
  fill: "currentColor",
  d: "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm1.645 5L13 14h-2l-.608-9h3.253zM12 20a2 2 0 11-.001-3.999A2 2 0 0112 20z"
}));
const AbstractDanger = ({
  theme,
  fill = '#fff',
  ...other
}) => theme.name === 'mds' ? _react.default.createElement(DangerMDS, (0, _extends2.default)({
  fill: fill
}, other)) : _react.default.createElement(DangerPrizm, (0, _extends2.default)({
  fill: fill
}, other));
var _default = exports.default = (0, _styledComponents.withTheme)(AbstractDanger);